
import { Component, Prop, Vue } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<ItemFailuresModal>({
	components: {
		StandardModal
	}
})
export default class ItemFailuresModal extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private showModal!: boolean;
	@Prop({ type: Array, required: true }) private locations!: FailedLocationRow[];
	@Prop({ type: Number, required: true }) private failedCount!: number;

	/**
	 * How many individual failures this modal can actually name. Lower than `failedCount` whenever a
	 * cap trimmed the detail.
	 *
	 * @return {number}
	 */
	private get shownCount(): number {
		return this.locations.reduce((sum: number, location: FailedLocationRow) => sum + location.errors.length, 0);
	}

	private get truncated(): boolean {
		return this.shownCount < this.failedCount;
	}
}
